<template>
  <div class="box-preview mt-2" v-if="name">
    <span>Combo</span>
    <h3 class="f-bold">{{ name }}</h3>
    <div class="box-preview-content" v-if="internetPlan">
      <div class="box-preview-content-title">
        <img src="../../assets/img/internet-white--servicos.png" alt="" />
        INTERNET FIXA
      </div>
      <p v-for="description in internetPlan.descriptions">
        <img src="../../assets/img/check-circle.svg" alt="" /> {{ description }}
        <br />
      </p>
      <hr />
    </div>

    <div class="box-preview-content" v-if="tvPlan">
      <div class="box-preview-content-title">
        <img src="../../assets/img/tv-white-servicos.png" alt="" />
        {{ tvPlan.name }}
      </div>
      <p v-for="description in tvPlan.descriptions">
        <img src="../../assets/img/check-circle.svg" alt="" /> {{ description }}
        <br />
      </p>
      <hr />
    </div>

    <div class="box-preview-content" v-if="phonePlan">
      <div class="box-preview-content-title">
        <img src="../../assets/img/icon_phone_white.png" alt="" />
        TELEFONE FIXO
      </div>
      <span
        ><img src="../../assets/img/check-circle.svg" alt="" /> {{ phonePlan.name }}</span
      >
      <p v-for="description in phonePlan.descriptions">
        <img src="../../assets/img/check-circle.svg" alt="" /> {{ description }}
        <br />
      </p>
    </div>

    <div class="box-preview-content" v-if="internetPlan">
      <span style="font-weight: bold">A Partir de:</span>
      <div class="box-preview-value d-flex">
        <p>{{ sumPrice({internetPlan, tvPlan, phonePlan}).toString().split(".")[0] - 20 }},</p>
        <span style="font-size: 20px; font-weight: bold">{{ sumPrice({internetPlan, tvPlan, phonePlan}).toFixed(2).split(".")[1] }}</span>
        <div class="d-flex align-items-end">
          <p>Por Mês*</p>
        </div>
      </div>
    </div>

    <p v-if="internetPlan">Valor sem fidelidade: {{ sumPrice({ internetPlan, tvPlan, phonePlan}).toFixed(2) }}</p>
  </div>
</template>

<script>
export default {
  props: ["name", "internetPlan", "tvPlan", "phonePlan"],

  mounted() {},

  computed: {
    combo() {
      return { internetPlan: this.internetPlan, tvPlan: this.tvPlan, phonePlan: this.phonePlan }
    }
  },

  methods: {
    sumPrice(combo) {
      let price = 0;
      if (combo.internetPlan) {
        price += combo.internetPlan.price;
      }
      if (combo.tvPlan) {
        price += combo.tvPlan.price;
      }
      if (combo.phonePlan) {
        price += combo.phonePlan.price;
      }
      return price;
    }
  },
};
</script>

<style>
.box-preview {
  display: flex;
  flex-direction: column;

  color: #fff;
  background-color: #363636;

  padding: 20px 40px;
  max-width: 320px;
  border-radius: 10px;
}
.box-preview-content p {
  font-size: 13px;
  margin-top: 10px;
}
.box-preview-content-title {
  display: flex;
  font-weight: bold;
  font-size: 16px;
  margin-top: 10px;
}
.box-preview-content-title img {
  height: 25px;
  margin-right: 10px;
}
.box-preview-value p:first-child {
  font-size: 40px;
  font-weight: bold;
}
.box-preview-value p:last-child {
  font-size: 13px;
}

.f-bold {
  font-weight: bold;
}
.box-preview span,
h3 {
  text-align: center;
}
.box-preview span {
  font-weight: normal;
}
</style>
